import classNames from "classnames";

import { getVendorLogo } from "helpers/utility/utilities";
import ModelTypeBadge from "views/components/ModelTypeBadge";

import styles from "./style.module.scss";
import VLTooltip from "views/uikit/VLTooltip";
import React, { useMemo } from "react";
import VLCheckBox from "views/uikit/VLCheckbox";

interface CreationModelListProps {
  model: any;
  isSelected: boolean;
  onSelect: (modelId: string, newPrompt?: boolean) => void;
  PromptTextAreaComponent?: JSX.Element;
  disabled?: boolean;
  dependencyMessage?: string;
}

const CreationModelList = ({
  onSelect,
  model,
  PromptTextAreaComponent,
  isSelected,
  disabled = false,
  dependencyMessage,
}: CreationModelListProps) => {
  const isComingSoon = model.status === "Coming Soon";
  const checkboxDisabled = isComingSoon || disabled;
  const selectionEnabled = !isComingSoon && !disabled;

  const modelClassNames = classNames(styles.model, {
    [styles.selectedModel]: isSelected,
    [styles.pointer]: selectionEnabled,
  });

  const assetPath = useMemo(
    () => getVendorLogo(model.vendor_logo_uri),
    [model.vendor_logo_uri],
  );

  const vendorLogoFileName = model.vendor_logo_uri.split(".")[0] || "";

  return (
    <div
      className={modelClassNames}
      onClick={() => selectionEnabled && onSelect(model.id)}
    >
      <div className={styles.modelHeaderContainer}>
        <div className={styles.modelHeader}>
          <VLTooltip title={dependencyMessage}>
            <VLCheckBox
              checked={isSelected}
              disabled={checkboxDisabled}
              onChange={(e) => e.stopPropagation()}
            />
          </VLTooltip>
          <div className={styles.icon}>
            <img src={assetPath} alt={vendorLogoFileName} />
          </div>
          <div className={styles.title} title={model.name}>
            {model.name}
          </div>
        </div>
        {isComingSoon && (
          <div className={styles.comingSoon}>⚡️ Coming Soon</div>
        )}
        <div className={styles.badgeContainer}>
          <ModelTypeBadge modelType={model.type} />
        </div>
      </div>
      {model.description && (
        <div className={styles.modelDescription}>{model.description}</div>
      )}

      {PromptTextAreaComponent}
    </div>
  );
};

export default React.memo(CreationModelList);
